import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/http/api.service';
import { buildHttpOptions } from 'app/core/http/BuildHttpOptions';
import { Observable } from 'rxjs';

export interface SalesAdminLightDashboardSummaryResponse {
    reservedVehicles: SalesAdminLightDashboardVehicleDto[];
    contractsInProgress: SalesAdminLightDashboardContractInProgressDto[];
    soldCarsThisWeek: SalesAdminLightDashboardSoldCarDto[];
    pendingDeliveries: number;
    totalContracts: SalesAdminLightDashboardContractDto[];
    topSellers: SalesAdminLightDashboardTopSellerDto[];
}

export interface SalesAdminLightDashboardVehicleDto {
    expiringSoon: boolean;
}

export interface SalesAdminLightDashboardContractInProgressDto {
    awaitingDocs: boolean;
}

export interface SalesAdminLightDashboardSoldCarDto {
    delivered: boolean;
}

export interface SalesAdminLightDashboardTopSellerDto {
    sellerId: string;
    sellerName: string;
    contractsClosed: number;
}

export interface SalesAdminLightDashboardContractDto {
    date: string;
    status: LegacyContractStatusEnum;
}

export enum LegacyContractStatusEnum {
    Unknown = 0,
    Canceled = 1,
    InProcess = 2,
    Completed = 3,
    Accounted = 4,
}

@Injectable({ providedIn: 'root' })
export class SalesAdminLightDashboardService {
    constructor(private readonly api: ApiService) {}

    getDashboardData(soldCarsTimePeriod: string, year: number, salesPeriod: string): Observable<SalesAdminLightDashboardSummaryResponse> {
        const options = buildHttpOptions({
            extraParams: { soldCarsTimePeriod, year, salesPeriod },
        });

        return this.api.get<SalesAdminLightDashboardSummaryResponse>('/dashboard/sales-admin-light/summary', options);
    }
}

